import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=90b8065a"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheShare: require('/home/korzinka/www/front/components/TheShare.vue').default,CouponWrapper: require('/home/korzinka/www/front/components/CouponWrapper.vue').default})
